import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormErrorHandler } from '../modules/shared/helpers/form-error-handler.helper';
import { ActivatedRoute } from '@angular/router';
import { AccountUserService } from '../service/account.service';
import * as CryptoJS from 'crypto-js';
import { MessageService } from 'primeng/api';
import { AppMainService } from '../app-main.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

    resetPasswordForm: FormGroup;
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    detailsFormErrors: any = {};
    showPassword: boolean = false;
    showEyeIcon: boolean = false;
    showSuccessMessage: boolean = false;
    userId: string;
    accessCode: any;
    encryptSecretKey = "LionO3602.0CRM2021";
    linkExpired: boolean = false;
    assestBaseUrl: string = environment.assestsBasePath;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private accountService: AccountUserService,
        private messageService: MessageService,
        private appMainService: AppMainService,
        ) {
    }

    ngOnInit(): void {
        this.passwordForm();
        this.route.queryParams.subscribe(params => {
            this.userId = params['userid'];
            this.accessCode = params['accesscode'];
        });

        this.verifyEmailIdForPasswordReset( this.userId, this.accessCode);
    }


    passwordForm() {
        this.detailsFormErrors = {};
        this.resetPasswordForm = this.formBuilder.group({
            newPassword: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&]).*$/
            )]],
            confirmNewPassword: ['', [Validators.required]]
        }, { validators: this.passwordMatchValidator });
        this.formErrorHandler.handleErrors(
            this.resetPasswordForm,
            this.detailsFormErrors,
            {
                newPassword: {
                    required: "Please Enter New Password",
                    minLength: "Password must be at least 8 characters long",
                    pattern: " Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character."
                },
                confirmNewPassword: {
                    required: "Please Confirm New Password",
                },
            }
        );
    }

    onForgotPasswordSubmit() {

        if (this.resetPasswordForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            return;
        }

        const userDetail: any = {
            emailId: this.userId,
            password: this.encryptData(this.resetPasswordForm.value.newPassword),
            newPassword: this.encryptData(this.resetPasswordForm.value.confirmNewPassword),
            accesscode: this.accessCode
        }

        this.accountService.onSubmitforgotPassword(userDetail).subscribe({
            next: () => {
                this.appMainService.isHideSpinner('forgotPassword');
                this.messageService.add({ severity: 'success', summary: 'Updated', detail: 'Password updated successfully.' });
            },
            error: (error) => {
                this.appMainService.isHideSpinner('forgotPassword');
                this.messageService.add({ severity: 'error', summary: 'Update Failed', detail: 'Failed to update password, please try again.' });
            }
        });

        this.showSuccessMessage = true;

    }

    passwordMatchValidator(control: AbstractControl) {
        const newPassword = control.get('newPassword').value;
        const confirmNewPassword = control.get('confirmNewPassword').value;
        return newPassword === confirmNewPassword ? null : { validateEqual: true };
    }

    onPasswordInput() {
        this.showEyeIcon = true;
        const passwordInput = this.resetPasswordForm.get('newPassword');
        if (passwordInput.value && passwordInput.value.length > 0) {
            this.showPassword = false;
        } else {
            this.showEyeIcon = false;
        }
    }

    encryptData(msg) {
        let keySize = 256;
        let salt = CryptoJS.lib.WordArray.random(16);
        let key = CryptoJS.PBKDF2(this.encryptSecretKey, salt, {
            keySize: keySize / 32,
            iterations: 100
        });

        let iv = CryptoJS.lib.WordArray.random(128 / 8);

        let encrypted = CryptoJS.AES.encrypt(msg, key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });

        let result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));

        return result;
    }

    verifyEmailIdForPasswordReset(encryptedEmailId, accessCode){
        this.accountService.verifyEmailForResetPassword(encryptedEmailId,accessCode).subscribe({
            next: (res:any) => {
                this.appMainService.isHideSpinner('forgotPassword');
                let response = res;
                this.linkExpired = !response.isSuccess; // Check the isSuccess property
            },
            error: (error) => {
                this.appMainService.isHideSpinner('forgotPassword');
                if(!error.error.isSuccess){
                    this.linkExpired = true;
                }

            }
        });
    }
}

